// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b08c42d7","455":"fa79da2b"}[chunkId] + ".chunk.js";
};